import { Flex, useBreakpointValue } from "@chakra-ui/react";
import NavCard from "./Card";

const HomeCards = () => {
  const cardMarginTop = useBreakpointValue({ base: "0px", md: "35px" });

  return (
    <Flex
      gap={10}
      flexWrap="wrap"
      justify="center"
      w="100vw"
      bg="bg.100"
      p="85px 0px"
    >
      <NavCard
        text="Rules"
        url="rules"
        backText="Learn the basics to get started."
        mT={cardMarginTop}
      />
      <NavCard
        text="Strategy"
        url="strategy"
        backText="Expand on your knowlede by taking a deep dive into statistics & strategy."
      />
      <NavCard
        text="Practice"
        url="practice"
        backText="Sharpen your skills with some practice by completing various tutorials."
        mT={cardMarginTop}
      />
      <NavCard
        text="Play"
        url="play"
        backText="Play online now with members of the Learn Setback community."
      />
    </Flex>
  );
};
export default HomeCards;


